const BID_ACTIONS = {
  INITIALIZE: "initialize",
  UPDATE_HIGHEST_BID: "update highest bid",
  RECOMPUTE_MIN_BID: "recompute min bid",
  UNFLASH: "unflash"
};

export default BID_ACTIONS;
